const SERVER_URL = process.env.REACT_APP_AGENCY_SERVER_API;
const API_PATH = `${SERVER_URL}/api/v1`;

module.exports = {
  AID_CONNECT: `${API_PATH}/aid-connect`,
};
